<template>
  <v-app>
    <v-content>
      <section id="hero">
        <v-row no-gutters>
          <v-img
            :min-height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
            src="./assets/hero.jpg"
          >
            <v-theme-provider dark>
              <v-container fill-height>
                <v-row align="center" class="white--text mx-auto" justify="center">
                  <v-col class="white--text text-center" cols="12" tag="h1">
                    <span
                      class="font-weight-light"
                      :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']"
                    >Tanel Tekko</span>

                    <br />

                    <span
                      :class="[$vuetify.breakpoint.smAndDown ? 'display-3': 'display-4']"
                      class="font-weight-black"
                    >Portfolio</span>
                  </v-col>

                  <v-btn class="align-self-end" fab outlined @click="$vuetify.goTo('#about-me')">
                    <v-icon>mdi-chevron-double-down</v-icon>
                  </v-btn>
                </v-row>
              </v-container>
            </v-theme-provider>
          </v-img>
        </v-row>
      </section>

      <section id="about-me">
        <div class="py-12"></div>

        <v-container class="text-center">
          <h2 class="display-2 font-weight-bold mb-3">ABOUT ME</h2>

          <v-responsive class="mx-auto mb-8" width="56">
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-responsive
            class="mx-auto title font-weight-light mb-8"
            max-width="720"
          >Two years developer experience. All info in cv and linkedin</v-responsive>

          <v-avatar class="elevation-12 mb-12" size="128">
            <v-img src="./assets/me.jpg"></v-img>
          </v-avatar>

          <div></div>

          <v-btn color="grey" outlined large :href="cv">
            <span class="grey--text text--darken-1 font-weight-bold">CV</span>
          </v-btn>
        </v-container>

        <div class="py-12"></div>
      </section>

      <section id="features" class="grey lighten-3">
        <div class="py-12"></div>

        <v-container class="text-center">
          <h2 class="display-2 font-weight-bold mb-3">SKILLS</h2>

          <v-responsive class="mx-auto mb-12" width="56">
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-row>
            <v-col v-for="({ icon, title, text }, i) in features" :key="i" cols="12" md="4">
              <v-card class="py-12 px-4" color="grey lighten-5" flat>
                <v-theme-provider dark>
                  <div>
                    <v-avatar color="primary" size="88">
                      <v-icon large v-text="icon"></v-icon>
                    </v-avatar>
                  </div>
                </v-theme-provider>

                <v-card-title
                  class="justify-center font-weight-black text-uppercase"
                  v-text="title"
                ></v-card-title>

                <v-card-text class="subtitle-1" v-text="text"></v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <div class="py-12"></div>
      </section>

      <section id="stats">
        <v-parallax :height="$vuetify.breakpoint.smAndDown ? 700 : 500" src="./assets/para.jpg">
          <v-container fill-height>
            <v-row class="mx-auto">
              <v-col v-for="[value, title, link] of stats" :key="title" cols="12" md="6">
                <a :href="link" class="links">
                  <div class="text-center">
                    <div class="display-3 font-weight-white mb-4">
                      <v-icon x-large>{{value}}</v-icon>
                    </div>

                    <div class="title font-weight-regular text-uppercase" v-text="title"></div>
                  </div>
                </a>
              </v-col>
            </v-row>
          </v-container>
        </v-parallax>
      </section>

      <section id="blog">
        <div class="py-12"></div>

        <v-container>
          <h2 class="display-2 font-weight-bold mb-3 text-uppercase text-center">Projects</h2>

          <v-responsive class="mx-auto mb-12" width="56">
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-row>
            <v-col
              v-for="({ text, title, gitlink, img, livelink }, i) in articles"
              :key="i"
              cols="12"
              md="4"
            >
              <v-img :src="getSrc(img)" class="mb-4" height="275" max-width="100%"></v-img>

              <h3 class="font-weight-black mb-4 text-uppercase" v-text="title"></h3>

              <div class="title font-weight-light mb-5" v-text="text"></div>

              <v-btn class="ml-n4 font-weight-black" color="primary" text :href="livelink" v-if="livelink != ''">Web view</v-btn>
              <v-btn class="ml-n4 font-weight-black"  text :href="gitlink" v-if="gitlink != ''" color="error">Github repo</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              v-for="({ text, title, gitlink, img, livelink }, i) in articles2"
              :key="i"
              cols="12"
              md="4"
            >
              <v-img :src="getSrc(img)" class="mb-4" height="275" max-width="100%"></v-img>

              <h3 class="font-weight-black mb-4 text-uppercase" v-text="title"></h3>

              <div class="title font-weight-light mb-5" v-text="text"></div>

              <v-btn class="ml-n4 font-weight-black" color="primary" text :href="livelink" v-if="livelink != ''">Web view</v-btn>
              <v-btn class="ml-n4 font-weight-black"  text :href="gitlink" v-if="gitlink != ''" color="error">Github repo</v-btn>
            </v-col>
          </v-row>
        </v-container>

        <div class="py-12"></div>
      </section>
    </v-content>

    <v-footer class="justify-center" color="#292929" height="100">
      <div
        class="title font-weight-light grey--text text--lighten-1 text-center"
      >&copy; {{year}} — Tanel Tekko</div>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "App",
  methods: {
    getSrc(name) {
        var images = require.context("./assets/", false, /\.png$/);
        return images("./" + name );
    }
  },
  data: () => ({
    //
    year: new Date().getFullYear(),
    cv:
      "https://docs.google.com/document/d/1U3NZpixc4AhAcuvFWFw3kKwqyJmp2eU95Zft6B8lOvA/edit?usp=sharing",
    articles: [
      {
        title: "Face recognition app",
        img: "face.png",
        text: "Face recognition app created using React",
        gitlink: "https://github.com/aquafinatrippy/facereg",
        livelink: "https://aquafinatrippy.github.io/facereg/"
      },
      {
        title: "Breaking Bad",
        img: "breakingbad.png",
        text: "Breaking bad app created using Angular",
        gitlink: "https://github.com/aquafinatrippy/Breaking-bad",
        livelink: "https://breakingbadsearcher.herokuapp.com/"
      },
      {
        title: "Rektek",
        img: "rektek.png",
        text: "One of my first projects, created using only html and css",
        gitlink: "https://github.com/aquafinatrippy/Rektek",
        livelink: "https://aquafinatrippy.github.io/Rektek/"
      }
    ],
    articles2: [
      {
        title: "Meriferm",
        img: "meriferm.png",
        text: "First freelance project, using wordpress",
        gitlink: "",
        livelink: "https://meriferm.ee/"
      },
      {
        title: "Sgreklaam",
        img: "sgreklaam.png",
        text: "Freelance project, created using wordpress",
        gitlink: "",
        livelink: "http://sgreklaam.eu/"
      }
    ],
    features: [
      {
        icon: "mdi-account-group-outline",
        title: "JAVASCRIPT",
        text:
          "1 year experience as javascript full-stack developer. Node js, Vue js and mongodb"
      },
      {
        icon: "mdi-update",
        title: "PHP",
        text:
          "Half year experience as PHP full-stack developer. Vanilla, Laravel, Prestashop and Drupal"
      },
      {
        icon: "mdi-shield-outline",
        title: "PYTHON",
        text:
          "Only have done courses and for my own fun projects. Vanilla and Django"
      }
    ],
    stats: [
      ["mdi-github", "Github", "https://github.com/aquafinatrippy"],
      [
        "mdi-linkedin",
        "linkedin",
        "https://www.linkedin.com/in/tanel-tekko-096b9a185/"
      ]
    ]
  })
};
</script>

<style scoped lang="scss">
.v-icon {
  color: #ffffff !important;
}
.links {
  text-decoration: none;
}
.v-application a {
  color: #ffffff;
}
</style>
